import { Instance } from 'mobx-state-tree';
import { TeamMemberDtoEdgeModelBase } from './TeamMemberDtoEdgeModel.base';

/* The TypeScript type of an instance of TeamMemberDtoEdgeModel */
export interface TeamMemberDtoEdgeModelType extends Instance<typeof TeamMemberDtoEdgeModel.Type> {}

/* A graphql query fragment builders for TeamMemberDtoEdgeModel */
export { selectFromTeamMemberDtoEdge, teamMemberDtoEdgeModelPrimitives, TeamMemberDtoEdgeModelSelector } from './TeamMemberDtoEdgeModel.base';

/**
 * TeamMemberDtoEdgeModel
 */
export const TeamMemberDtoEdgeModel = TeamMemberDtoEdgeModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
